import { Filter, TextInput, useListContext } from "react-admin";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { memo } from "react";

interface ListSearchFilterProps {
  searchFields?: string[];
  className?: string;
  [key: string]: any;
}

export const ListSearchFilter = memo((props: ListSearchFilterProps) => {
  const { loading } = useListContext();
  useSearchFields(props, props.searchFields || []);

  return (
    <Filter {...props}>
      <TextInput
        key="search-input"
        className={`${
          props.className || "fleet-managers-list-filter"
        } search-box`}
        label="resources.common.labels.search"
        source="q"
        alwaysOn
        autoFocus={!loading}
        autoComplete="off"
      />
    </Filter>
  );
});

ListSearchFilter.displayName = "ListSearchFilter";
